<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h1 class="header">How far can you walk?</h1>
                <h2 class="subheader"></h2>
            </div>
        </div>
        <div v-if="generalErrorMessage" class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <div class="alert alert-danger" role="alert">
                    {{ generalErrorMessage }}
                </div>
            </div>
            <div class="col-xl-3"></div>
        </div>
        <div class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <form @submit.prevent="submit()">
                    <div class="form-row">
                        <div class="col-md-6">
                            <b-form-group label="Distance" :state="stateForField('kneeWalkDistance')" :invalid-feedback="errorForField('kneeWalkDistance')">
                                <b-form-input pattern="\d*" @input="clearFieldError('kneeWalkDistance')" size="lg" :state="stateForField('kneeWalkDistance')" v-model="orthoReasonForVisit.kneeWalkDistance"></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="Units" :state="stateForField('kneeWalkDistanceUnit')" :invalid-feedback="errorForField('kneeWalkDistanceUnit')">
                                <b-form-select size="lg" @input="clearFieldError('kneeWalkDistanceUnit')" v-model="orthoReasonForVisit.kneeWalkDistanceUnit" :state="stateForField('kneeWalkDistanceUnit')" :options="distanceUnitOptions"></b-form-select>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="form-row">
                        <button type="submit" @click.prevent="submit()" class="btn btn-primary btn-lg mx-auto mt-2" style="width: 40%"><font-awesome-icon class="mr-2" v-show="isSaving" icon="spinner" pulse/>Next</button>
                    </div>
                </form>
            </div>
            <div class="col-xl-3"></div>
        </div>
    </div>
</template>

<script>
  import api from '../../services/api'
  import ErrorsMixin from '../../mixins/ErrorsMixin'
  import OptionsMixin from '../../mixins/OptionsMixin'
  import OrthoMixin from '../../mixins/OrthoMixin'
  import { BFormInput, BFormSelect, BFormGroup } from 'bootstrap-vue'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'OrthoKneeDistance',

    components: { BFormGroup, BFormInput, BFormSelect },

    mixins: [ErrorsMixin, OptionsMixin, OrthoMixin, AnalyticsMixin],

    data () {
      return {
        orthoReasonForVisit: {
          primaryBodyPart: {
            code: '',
            name: ''
          },
          kneeWalkDistance: null,
          kneeWalkDistanceUnit: null
        },
        isSaving: false
      }
    },

    computed: {

      distanceUnitOptions () {
        return [
          {
            value: 'Feet',
            text: 'Feet'
          },
          {
            value: 'Miles',
            text: 'Miles'
          },
          {
            value: 'Blocks',
            text: 'Blocks'
          }
        ]
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        return !this.hasErrors()
      },

      submit () {
        if (this.validate() !== true) {
          return
        }

        this.isSaving = true
        api.put('/Patient/OrthoReasonForVisit', this.orthoReasonForVisit).then(response => {
          this.trackEvent(this.$options.name, 'Save', 'ResponseTime', response.config.requestDuration)
          this.orthoReasonForVisit = response.data
          this.$router.push('ortho-knee-pain')

        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      loadData () {
        api.get('/Patient/OrthoReasonForVisit').then(response => {
          this.trackEvent(this.$options.name, 'Load', 'ResponseTime', response.config.requestDuration)
          this.orthoReasonForVisit = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
            this.setFromApiErrorResponse(error)
          }
        })
      }
    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>

</style>
